<template>
  <div class="dataDictManagement-container">
    <el-row>
      <el-col :span="11">
        <zr-query-form class="query-box">
          <zr-query-form-left-panel :span="24">
            <el-button
              icon="el-icon-plus"
              type="primary"
              @click="handleAddSonType"
              >添加子类</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-edit-outline"
              @click="handleTypeEdit"
              >编辑</el-button
            >
            <el-button
              type="success"
              icon="el-icon-s-order"
              @click="handleTypeView"
              ><span>查看</span>
            </el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="handleTypeDelete"
              ><span>删除</span>
            </el-button>
          </zr-query-form-left-panel>
        </zr-query-form>
        <zr-tree-table
          ref="basicDataTreeTable"
          height-fixed
          expand-all
          class="table-box"
          :loading-show="typeLoading"
          row-key="name"
          :data="list"
          :columns="realTypeCols"
          stripe
          enabled-selection
          selection-type="single"
          @current-change="rowSelected"
          @row-click="rowClick"
        >
        </zr-tree-table>
        <zr-comm-dialog
          title="数据类型"
          :width="device == 'mobile' ? '90%' : '60%'"
          :dialog-data="typeDialogData"
          :dialog-visible.sync="typeDialogVisible"
          :init-data-fun="initTypeDialogData"
          :save-data-fun="saveTypeDialogData"
          :rules="rules"
          @dialogVisibleChange="typeDialogVisibleChange"
          @callBack="typeDialogCallBack"
        >
          <template v-slot:dialog-content="{ form, dialogData }">
            <el-form-item label="上级节点" prop="parentName">
              <el-input
                v-model="form.parentName"
                placeholder="上级节点"
                clearable
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="类型名称" prop="name">
              <el-input
                v-model="form.name"
                placeholder="类型名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="类型编码" prop="code">
              <el-input
                v-model="form.code"
                placeholder="类型编码"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="类别" prop="type">
              <zr-combobox
                v-model="form.type"
                :data-array="typeArray"
                value-field="code"
                label-field="name"
              ></zr-combobox>
            </el-form-item>
            <el-form-item label="数据形式" prop="isMultiLayer">
              <zr-combobox
                v-model="form.isMultiLayer"
                :disabled="dialogData.action != 'add'"
                :data-array="isMultiLayerArray"
                value-field="code"
                label-field="name"
              ></zr-combobox>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input-number v-model="form.sort" :min="1"></el-input-number>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="form.remark"
                clearable
                type="textarea"
                maxlength="300"
                show-word-limit
                :rows="5"
                :autosize="{ minRows: 5, maxRows: 8 }"
                placeholder="备注"
              ></el-input>
            </el-form-item>
          </template>
        </zr-comm-dialog>
      </el-col>
      <el-col :span="12" :push="1" style="overflow: auto;">
        <zr-query-form class="query-box">
          <zr-query-form-left-panel :span="24">
            <template v-if="cutTableMod == 'list'">
              <el-button
                icon="el-icon-plus"
                type="primary"
                @click="handleAddData"
                >添加</el-button
              >
            </template>
            <template v-if="cutTableMod == 'tree'">
              <el-button
                icon="el-icon-plus"
                type="primary"
                @click="handleAddParentData"
                >添加顶级数据</el-button
              >
              <el-button
                icon="el-icon-plus"
                type="primary"
                @click="handleAddSonData"
                >添加子级数据</el-button
              >
            </template>
            <el-button
              type="primary"
              icon="el-icon-edit-outline"
              @click="handleEditData"
              >编辑
            </el-button>
            <el-button
              type="success"
              icon="el-icon-s-order"
              @click="handleViewData"
              ><span>查看</span>
            </el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="handleDeleteData"
              ><span>删除</span>
            </el-button>
            <el-button
              icon="el-icon-refresh"
              type="warning"
              @click="handleReloadBasicData"
              >重新加载</el-button
            >
          </zr-query-form-left-panel>
        </zr-query-form>
        <component
          :is="curTable"
          ref="dataTable"
          row-key="code"
          :expand-all="false"
          enabled-selection
          selection-type="single"
          class="table-box"
          :loading-show="dataLoading"
          :data="datalist"
          :columns="realDataCols"
          @row-click="dataRowClick"
        >
        </component>
        <zr-comm-dialog
          title="字典数据"
          :dialog-data="dataDialogData"
          :dialog-visible.sync="dataDialogVisible"
          :init-data-fun="initDataDialogData"
          :save-data-fun="saveDataDialogData"
          :rules="rules"
          :width="device == 'mobile' ? '90%' : '60%'"
          @dialogVisibleChange="dataDialogVisibleChange"
          @callBack="dataDialogCallBack"
        >
          <template v-slot:dialog-content="{ form }">
            <el-form-item label="名称" prop="name">
              <el-input
                v-model="form.name"
                placeholder="名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="编码" prop="code">
              <el-input
                v-model="form.code"
                placeholder="编码"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="简称" prop="nameForShort">
              <el-input
                v-model="form.nameForShort"
                placeholder="简称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="orderBy">
              <el-input-number v-model="form.orderBy"></el-input-number>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="form.remark"
                clearable
                type="textarea"
                maxlength="1000"
                show-word-limit
                :rows="5"
                :autosize="{ minRows: 5, maxRows: 8 }"
                placeholder="备注"
              ></el-input>
            </el-form-item>
          </template>
        </zr-comm-dialog>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getTree,
  saveDataDictType,
  saveData,
  findDataListByTypeCode,
  findDataTreeByTypeCode,
  deleteType,
  deleteData,
  findBasicDataTypeById,
  reloadBasicData,
} from "@/api/framework/basicData/dataDictType";
import listTable from "zr-table/src/components/zr/table/index";
import treeTable from "zr-table/src/components/zr/table/treeTable";
import { isArray } from "zr-util/src/utils/comm/validate";
import { messageDuration } from "../../../../config/settings";
export default {
  name: "Index",
  data() {
    return {
      typeLoading: false,
      dataLoading: false,
      list: [],
      cutTableMod: "list",
      datalist: [],
      typeArray: [
        { code: "systemDefine", name: "系统" },
        { code: "userDefine", name: "自定义" },
      ],
      isMultiLayerArray: [
        { code: 0, name: "列表" },
        { code: 1, name: "树型" },
      ],
      typeColumns: [
        {
          code: "name",
          name: "类型名称",
          width: "180",
          headerAlign: "left",
          align: "left",
        },
        { code: "code", name: "类型编码" },
        {
          code: "type",
          name: "类别",
          formatter: (row, value) => {
            const array = this.typeArray;
            for (let i = 0, len = array.length; i < len; i++) {
              if (value == array[i].code) {
                return array[i].name;
              }
            }
            return value;
          },
        },
        {
          code: "isMultiLayer",
          name: "数据形式",
          formatter: (row, value) => {
            const array = this.isMultiLayerArray;
            for (let i = 0, len = array.length; i < len; i++) {
              if (value == array[i].code) {
                return array[i].name;
              }
            }
            return value;
          },
        },
      ],
      dataColumns: [
        { code: "name", name: "名称" },
        { code: "code", name: "编码" },
        { code: "nameForShort", name: "简称" },
        { code: "orderBy", name: "排序" },
        { code: "remark", name: "说明" },
      ],
      queryForm: {
        code: "",
      },
      typeDialogData: {},
      typeAddInitData: {
        id: null,
        name: "",
        code: "",
        parentName: "",
        isMultiLayer: 0,
        pid: "",
        type: "systemDefine",
        sort: 1,
        remark: "",
      },
      typeDialogVisible: false,
      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "长度在 1 到 100 个字符",
            trigger: "blur",
          },
        ],
        code: [
          { required: true, message: "请输入编码", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "长度在 1 到 100 个字符",
            trigger: "blur",
          },
        ],
      },
      dataDialogData: {},
      dataAddInitData: {
        id: null,
        name: "",
        nameForShort: "",
        code: "",
        typeCode: "",
        value: "",
        orderBy: 1,
        remark: "",
      },
      dataDialogVisible: false,
      dataRow: null,
      sonDataRow: null,
    };
  },
  computed: {
    ...mapGetters({
      device: "settings/device",
    }),
    curTable() {
      return this.cutTableMod == "list" ? listTable : treeTable;
    },
    realTypeCols() {
      if (this.device == "mobile") {
        return this.typeColumns.slice(0, 2);
      } else {
        return this.typeColumns;
      }
    },
    realDataCols() {
      if (this.device == "mobile") {
        return this.dataColumns.slice(0, 2);
      } else {
        return this.dataColumns;
      }
    },
  },
  async created() {
    await this.fetchTypeData();
  },
  methods: {
    async handleReloadBasicData() {
      const res = await reloadBasicData();
      if (res.success) {
        this.$message.success({
          showClose: true,
          message: "重新加载数据字典成功",
          duration: messageDuration,
        });
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    dataRowClick(row) {
      this.sonDataRow = row;
    },
    handleAddSonType() {
      if (this.dataRow == null) {
        this.$message.warning({ showClose: true, message: "请选择父节点" });
      } else {
        const parentName = this.dataRow.name;
        const pid = this.dataRow.id;
        this.typeDialogData = {
          action: "add",
          data: {
            ...this.typeAddInitData,
            parentName,
            pid,
          },
        };
        this.typeDialogVisible = true;
      }
    },
    async handleTypeEdit() {
      const row = this.dataRow;
      if (row) {
        let pid = "";
        let parentName = "";
        if (row.pid) {
          const res = await findBasicDataTypeById({ id: row.pid });
          if (res.success) {
            parentName = res.data.name;
            pid = row.pid;
          } else {
            this.$message.error({ showClose: true, message: res.message });
          }
        }
        this.typeDialogData = {
          action: "edit",
          data: { ...row, pid, parentName },
        };
        this.typeDialogVisible = true;
      } else {
        this.$message.warning({ showClose: true, message: "请选择数据行" });
      }
    },
    async handleTypeView() {
      const row = this.dataRow;
      if (row) {
        let parentName = "";
        if (row.pid) {
          const res = await findBasicDataTypeById({ id: row.pid });
          if (res.success) {
            parentName = res.data.name;
          } else {
            this.$message.error({ showClose: true, message: res.message });
          }
        }
        this.typeDialogData = { action: "view", data: { ...row, parentName } };
        this.typeDialogVisible = true;
      } else {
        this.$message.warning({ showClose: true, message: "请选择数据行" });
      }
    },
    handleTypeDelete() {
      const row = this.dataRow;
      if (row) {
        this.$confirm("确认删除这个数据类型吗？")
          .then(async () => {
            let re_data = await deleteType({
              basicDataType: JSON.stringify(row),
            });
            if (re_data.success) {
              await this.fetchTypeData();
              this.$message.success({
                showClose: true,
                message: "删除成功！",
                duration: messageDuration,
              });
            } else {
              this.$message.error({
                showClose: true,
                message: "删除失败！" + re_data.message,
              });
            }
          })
          .catch(() => {
            this.$message.info({ showClose: true, message: "已取消删除" });
          });
      } else {
        this.$message.warning({ showClose: true, message: "请选择数据行" });
      }
    },
    handleAddData() {
      if (!this.dataRow) {
        this.$message.warning({
          showClose: true,
          message: "请先选中类型数据！",
        });
      } else {
        const typeCode = this.dataRow.code;
        this.dataDialogData = {
          action: "add",
          data: { ...this.dataDialogData, typeCode },
        };
        this.dataDialogVisible = true;
      }
    },
    handleAddParentData() {
      if (!this.dataRow) {
        this.$message.warning({
          showClose: true,
          message: "请先选中类型数据！",
        });
      } else {
        const typeCode = this.dataRow.code;
        this.dataDialogData = {
          action: "add",
          data: { ...this.dataDialogData, typeCode },
        };
        this.dataDialogVisible = true;
      }
    },
    handleAddSonData() {
      if (!this.sonDataRow) {
        this.$message.warning({
          showClose: true,
          message: "请先选中父级数据！",
        });
      } else {
        const typeCode = this.dataRow.code;
        const parentId = this.sonDataRow.id;
        this.dataDialogData = {
          action: "add",
          data: { ...this.dataDialogData, typeCode, parentId },
        };
        this.dataDialogVisible = true;
      }
    },
    handleEditData() {
      const row = this.sonDataRow;
      if (row) {
        this.dataDialogData = { action: "edit", data: row };
        this.dataDialogVisible = true;
      } else {
        this.$message.warning({
          showClose: true,
          message: "请选择要编辑的数据",
        });
      }
    },
    handleViewData() {
      const row = this.sonDataRow;
      if (row) {
        this.dataDialogData = { action: "view", data: row };
        this.dataDialogVisible = true;
      } else {
        this.$message.warning({
          showClose: true,
          message: "请选择要查看的数据",
        });
      }
    },
    async handleDeleteData() {
      const row = this.sonDataRow;
      if (row) {
        this.$confirm("确认删除这个数据吗？")
          .then(async () => {
            let re_data = await deleteData({ basicData: JSON.stringify(row) });
            if (re_data.success) {
              this.refreshPage();
              this.$message.success({
                showClose: true,
                message: "删除成功！",
                duration: messageDuration,
              });
            } else {
              this.$message.error({
                showClose: true,
                message: "删除失败！" + re_data.message,
              });
            }
          })
          .catch(() => {
            this.$message.info({ showClose: true, message: "已取消删除" });
          });
      } else {
        this.$message.warning({
          showClose: true,
          message: "请选择要删除的数据",
        });
      }
    },
    async refreshPage() {
      this.sonDataRow = undefined;
      await this.datasByTypeCode(this.dataRow);
    },
    async rowSelected(row) {
      await this.datasByTypeCode(row);
      this.sonDataRow = undefined;
    },
    async datasByTypeCode(type) {
      this.dataLoading = true;
      let res = undefined;
      if (type.isMultiLayer == 0) {
        res = await findDataListByTypeCode({ typeCode: type.code });
      } else {
        res = await findDataTreeByTypeCode({ typeCode: type.code });
      }
      if (res.success) {
        let data = res.data;
        if (isArray(data)) {
          this.datalist = data;
        } else {
          this.datalist = [];
        }
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }

      setTimeout(() => {
        this.dataLoading = false;
      }, 300);
    },
    async rowClick(row, column, event) {
      this.dataRow = row;
      if (this.dataRow.isMultiLayer == 0) {
        this.cutTableMod = "list";
      } else {
        this.cutTableMod = "tree";
      }
    },
    async fetchTypeData() {
      this.dataRow = undefined;
      this.typeLoading = true;
      const res = await getTree();
      if (res.success) {
        this.list = res.data;
        this.$nextTick(() => {
          this.$refs.basicDataTreeTable.$refs.table.$refs.elTable.setCurrentRow(
            this.list[0]
          );
          this.rowClick(this.list[0]);
          // this.rowSelected(this.list[0]);
        });
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }

      setTimeout(() => {
        this.typeLoading = false;
      }, 300);
    },
    typeDialogVisibleChange(val) {
      this.typeDialogVisible = val;
    },
    typeDialogCallBack(res) {
      if (res.success) {
        this.$message.success({
          showClose: true,
          message: "保存成功",
          duration: messageDuration,
        });
        this.fetchTypeData();
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    close() {
      this.typeDialogVisible = false;
      this.$emit("typeDialogVisibleChange", this.typeDialogVisible);
      this.dataDialogVisible = false;
      this.$emit("dataDialogVisibleChange", this.dataDialogVisible);
    },
    initTypeDialogData(data) {
      return data.data;
    },
    async saveTypeDialogData(data) {
      const res = await saveDataDictType({
        basicDataType: JSON.stringify(data),
      });
      return res;
    },
    dataDialogVisibleChange(val) {
      this.dataDialogVisible = val;
    },
    dataDialogCallBack(data) {
      if (data.success) {
        this.$message.success({
          showClose: true,
          message: "保存成功",
          duration: messageDuration,
        });
        this.refreshPage();
      } else {
        this.$message.error({
          showClose: true,
          message: "保存失败!" + data.message,
        });
      }
    },
    async initDataDialogData(data) {
      return data.data;
    },
    async saveDataDialogData(data) {
      const res = await saveData({ basicData: JSON.stringify(data) });
      return res;
    },
  },
};
</script>

<style scoped lang="scss">
@import "public/static/scss/commTableLayouts";
</style>
